// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\App\PilotsNavbar\PilotsNavbarViewModel.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';


// PilotsNavbarData is the class that PilotsNavbar serializes to/from
export interface PilotsNavbarData {
    Id : number;
	
	
    AcknowledgeCount : number;
    CanViewRotation : boolean;
}

// PilotsNavbarOptions is the class which may be passed to the PilotsNavbar constructor to define optional initial data values
export interface PilotsNavbarOptions {
    Id : number;
	
	
    AcknowledgeCount? : number;
    CanViewRotation? : boolean;
}

export class PilotsNavbar {
    public Id : DataSignal<number>;
	
	
    public AcknowledgeCount : DataSignal<number>;
    public CanViewRotation : DataSignal<boolean>;

    constructor();
    constructor(data : PilotsNavbarOptions);
    constructor(data: PilotsNavbarOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
	    
        this.AcknowledgeCount = jsonableObservable(S.value<number>(data && data.AcknowledgeCount !== undefined ? data.AcknowledgeCount : 0));
        this.CanViewRotation = jsonableObservable(S.value<boolean>(data && data.CanViewRotation !== undefined ? data.CanViewRotation : false));
    }

    static key(obj : PilotsNavbar) {
        return obj.Id();
    }
    
    static dataKey(obj : PilotsNavbarOptions) {
        return obj.Id;
    }

    static update(obj : PilotsNavbar, data : PilotsNavbarOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
	        
            if (data.AcknowledgeCount !== undefined) obj.AcknowledgeCount(data.AcknowledgeCount);
            if (data.CanViewRotation !== undefined) obj.CanViewRotation(data.CanViewRotation);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PilotsNavbar.ts